module.exports = __webpack_public_path__ + "img/icon-descarga.b8a2b7e6.svg";